import React, { Component } from 'react';
import { Row, Col, Modal, ModalBody, FormGroup, Input, Label, Button } from 'reactstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTimes } from '@fortawesome/free-solid-svg-icons';
import swal from 'sweetalert';
import Validation from '../../services/Validation';
import Storage from '../../services/Storage';
import NewFleetService from '../../services/NewFleetService';
import ModalService from '../../services/ModalService';
import { uuid } from 'uuidv4';
import CustomSpinner from '../CustomSpinner/CustomSpinner';
class InviteFleet extends Component {
  from = '';
  item = {};
  constructor(props) {
    super(props);
    this.state = {
      modal: false,
      userDetail: Storage.getUserDetail(),
      controls: {
        mobile_number: {
          value: null,
          valid: true,
          touched: false,
          required: true,
          showErrorMsg: false,
          isEditActive: false
        },
        company_name: {
          value: null,
          valid: true,
          touched: false,
          required: true,
          showErrorMsg: false,
          isEditActive: false
        },
        owner_name: {
          value: null,
          valid: true,
          touched: false,
          required: true,
          showErrorMsg: false,
          isEditActive: false
        },
        isInviteAgain: false,
      },
      oldDetail: {},
      isLoading: false
    }
    this.toggle = this.toggle.bind(this);
  }

  resetControls = () => {
    let { controls } = this.state;
    controls.mobile_number.value = '';
    controls.owner_name.value = '';
    controls.company_name.value = '';
    controls.company_name.showErrorMsg = false;
    controls.owner_name.showErrorMsg = false;
    controls.mobile_number.showErrorMsg = false;
    this.setState({ controls });
  }

  handleInputChange = (e) => {
    const controlName = e.target.name;
    const controlValue = e.target.value;
    const { controls } = this.state;
    controls[controlName].value = controlValue;
    controls[controlName].touched = true;
    this.setState({ controls });
    this.handleValidation(false);
  }


  handleValidation = (isSubmit = false) => {

    let { controls } = this.state;
    let { mobile_number, owner_name, company_name } = controls;
    if (mobile_number.touched === true || isSubmit) {
      mobile_number = Validation.notNullValidator(mobile_number);
      mobile_number = Validation.validatePhoneNumber(mobile_number);
      mobile_number = Validation.validateLength(mobile_number, 10);
      mobile_number.valid = !(mobile_number.invalidPhone || mobile_number.nullValue || mobile_number.invalidLength);
      if (mobile_number.valid === false) {
        mobile_number.showErrorMsg = true;
      } else {
        mobile_number.showErrorMsg = false;
      }
    }

    if (owner_name.touched === true || isSubmit) {
      owner_name = Validation.notNullValidator(owner_name);
      owner_name.valid = !(owner_name.nullValue);
      if (owner_name.valid === false) {
        owner_name.showErrorMsg = true;
      } else {
        owner_name.showErrorMsg = false;
      }
    }

    if (company_name.touched === true || isSubmit) {
      company_name = Validation.notNullValidator(company_name);
      company_name.valid = !(company_name.nullValue);
      if (company_name.valid === false) {
        company_name.showErrorMsg = true;
      } else {
        company_name.showErrorMsg = false;
      }
    }
    let isFormValid = false;
    if (company_name.valid === true &&
      owner_name.valid === true &&
      mobile_number.valid === true) {
      isFormValid = true;
    }
    this.setState({ controls });
    return isFormValid;
  }


  inviteFleet = async () => {
    let { controls, oldDetail } = this.state;
    if (!this.handleValidation(true)) {
      return
    }
    let reqData = {
      "fleet_manager": this.state.userDetail.uuid,
      "mobile_number": controls.mobile_number.value,
      "company_name": controls.company_name.value,
      "owner_name": controls.owner_name.value
    }
    this.setState({ isLoading: true });

    // save draft
    let getEnrollFleetReqData = {};
    if (this.props.from && this.props.from === 'enroll-new-fleet') {
      this.props.setBuinesssDetailFromInviteFleet(reqData);
      getEnrollFleetReqData = this.props.getEnrollFleetReqData(true);
      if (this.props.fleetByIdData && this.props.fleetByIdData.uuid) {
        getEnrollFleetReqData.uuid = this.props.fleetByIdData.uuid;
        try {
          // const { data } = await NewFleetService.editInviteFleet(getEnrollFleetReqData);
          await NewFleetService.editInviteFleet(getEnrollFleetReqData);
        } catch (e) {
          if (oldDetail && Object.keys(oldDetail).length > 0) {
            this.props.setBuinesssDetailFromInviteFleet(oldDetail);
          }
          if (e.response && e.response.data && e.response.data.error && e.response.data.error.length > 0) {
            ModalService.openAlert(e.response.data.error[0].message, '', 'error');
          }
          this.setState({ isLoading: false });
          return
        }
      } else {
        try {
          // const { data } = await NewFleetService.addInviteFleet(getEnrollFleetReqData);
          await NewFleetService.addInviteFleet(getEnrollFleetReqData);
        } catch (e) {
          if (oldDetail && Object.keys(oldDetail).length > 0) {
            this.props.setBuinesssDetailFromInviteFleet(oldDetail);
          }
          if (e.response && e.response.data && e.response.data.error && e.response.data.error.length > 0) {
            ModalService.openAlert(e.response.data.error[0].message, '', 'error');
          }
          this.setState({ isLoading: false });
          return
        }
      }
    } else {
      if (!controls.isInviteAgain) {
        reqData.temp_id = this.props.uuid ? this.props.uuid : uuid();
      }
    }

    NewFleetService.inviteFleet(reqData)
      .then(data => {
        if (data.data) {
          swal({
            title: 'Congratulations !',
            text: data.data.message,
            icon: 'success',
            type: 'success',
          }).then(value => {
            this.props.closeModal(this.props.uuid ? this.props.uuid : reqData.temp_id);
            this.toggle({});
          });
        }
        this.setState({ isLoading: false });
      })
      .catch(e => {
        if (e.response && e.response.data && e.response.data.error && e.response.data.error.length > 0) {
          ModalService.openAlert(e.response.data.error[0].message, '', 'error');
        }
        this.setState({ isLoading: false });
      });
  }



  toggle(data) {
    let { controls, oldDetail } = this.state;
    if (data && Object.keys(data).length > 0) {
      controls.company_name.value = data.company_name;
      controls.owner_name.value = data.owner_name;
      controls.mobile_number.value = data.mobile_number;
      controls.isInviteAgain = data.isInviteAgain ? true : false;
      oldDetail = data;
    } else {
      oldDetail = {};
      this.resetControls();
    }
    this.setState(prevState => ({
      ...prevState,
      modal: !prevState.modal,
      controls,
      oldDetail
    }));
  }
  render() {
    let { controls } = this.state;
    const externalCloseBtn = <button className="close" style={{ position: 'absolute', top: '15px', right: '15px' }} onClick={this.toggle}>&times;</button>;
    return (
      <>
        {this.state.isLoading && <CustomSpinner />}
        <Modal isOpen={this.state.modal} toggle={this.toggle} external={externalCloseBtn} className="modal-md modal-lg custom-confirm-modal width-30-pecentage" style={{ maxWidth: '1600px' }} backdrop={this.backdrop ? 'static' : 'nostatic'}>
          <div className="d-flex-column">
            <div className="confirm-modal-title-wrapp">
              <span className="confirm-modal-title">Invite Fleet</span>
              <FontAwesomeIcon className="pull-right cursor-pointer" onClick={() => this.toggle({})} icon={faTimes} style={{ fontSize: '20px', cursor: 'pointer' }} color="#fdbb1f" />
            </div>
          </div>
          <ModalBody classNam="d-flex-column">
            <Row>
              <Col xl="12.custom-confirm-modal" md="12" xs="12">
                <FormGroup>
                  <Label for="company_name">Company Name<span className="required-field">*</span></Label>
                  <Input
                    type="text"
                    name="company_name"
                    id="company_name"
                    onChange={(e) => this.handleInputChange(e)}
                    value={controls.company_name.value}
                    autoComplete="nofill"
                    placeholder="Type here" />
                  {controls.company_name.showErrorMsg && <div className="error">*Please enter company name.</div>}
                </FormGroup>
              </Col>
              <Col xl="12.custom-confirm-modal" md="12" xs="12">
                <FormGroup>
                  <Label for="owner_name">Owner Name<span className="required-field">*</span></Label>
                  <Input
                    type="text"
                    name="owner_name"
                    id="owner_name"
                    autoComplete="nofill"
                    value={controls.owner_name.value}
                    onChange={(e) => this.handleInputChange(e)}
                    placeholder="Type here" />
                  {controls.owner_name.showErrorMsg && <div className="error">*Please enter owner name.</div>}
                </FormGroup>
              </Col>
              <Col xl="12" md="12" xs="12">
                <FormGroup>
                  <Label for="mobile_number">Mobile Number<span className="required-field">*</span></Label>
                  <Input
                    type="text"
                    name="mobile_number"
                    id="mobile_number"
                    autoComplete="nofill"
                    maxLength="10"
                    value={controls.mobile_number.value}
                    onChange={(e) => this.handleInputChange(e)}
                    placeholder="Type here" />
                  {controls.mobile_number.showErrorMsg && <div className="error">* Please enter mobile number</div>}
                </FormGroup>
              </Col>
              <Col xl="12" xs="12" md="12" className="text-align-right mt-3" >
                <Button className="mb-1 mr-1 btn-pill action-button profile-save-button" color="warning" onClick={() => { this.inviteFleet(true) }}>Invite</Button>
              </Col>
            </Row>
          </ModalBody>
        </Modal>
      </>
    );
  }
}

export default InviteFleet;